const ATTRIBUTION_STORAGE_KEY = 'groovebaySearchAttribution';
const OUTCOME_EVENT_NAME = 'groovebay:search-miss-outcome';

const currentAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    referrer: document.referrer || '',
    utm: {
      source: params.get('utm_source'),
      medium: params.get('utm_medium'),
      campaign: params.get('utm_campaign'),
    },
  };
};

const hasUtm = attribution => Object.values(attribution?.utm || {}).some(Boolean);

/** Preserve first-touch referrer and campaign data for the current browser session. */
export const captureSearchAttribution = () => {
  if (typeof window === 'undefined') return { referrer: '', utm: {} };

  const current = currentAttribution();
  try {
    const storedRaw = window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    const stored = storedRaw ? JSON.parse(storedRaw) : null;
    const attribution = hasUtm(current) || !stored ? current : stored;
    window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
    return attribution;
  } catch (_) {
    return current;
  }
};

/** Generate one opaque identifier for a single rendered zero-result search. */
export const createSearchMissEventId = () => {
  if (typeof window !== 'undefined' && typeof window.crypto?.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}_${Math.random()
    .toString(36)
    .slice(2)}`;
};

/** Classify the current browser into the device groups requested for search-miss reporting. */
export const getSearchMissDevice = () => {
  if (typeof window === 'undefined') return 'desktop';

  const userAgent = window.navigator?.userAgent || '';
  const isTablet = /iPad|Tablet|PlayBook|Silk|Android(?!.*Mobile)/i.test(userAgent);
  if (isTablet) return 'tablet';
  if (/Mobi|Android|iPhone|iPod/i.test(userAgent)) return 'mobile';
  if (window.innerWidth <= 767) return 'mobile';
  if (window.innerWidth <= 1024) return 'tablet';
  return 'desktop';
};

/** Announce an outcome from search controls that render outside the zero-result card. */
export const announceSearchMissOutcome = outcome => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OUTCOME_EVENT_NAME, { detail: { outcome } }));
};

export const searchMissOutcomeEventName = OUTCOME_EVENT_NAME;
